// extracted by mini-css-extract-plugin
module.exports = {"disabled-form":"upload_disabled-form__2ZJjc"};